import { render } from "./DetalharTipoPlano.vue?vue&type=template&id=ea0bde64&scoped=true"
import script from "./DetalharTipoPlano.vue?vue&type=script&lang=js"
export * from "./DetalharTipoPlano.vue?vue&type=script&lang=js"

import "./DetalharTipoPlano.vue?vue&type=style&index=0&id=ea0bde64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea0bde64"]])

export default __exports__